import Vue from "vue";
import "ant-design-vue/dist/antd.min.css";
import {
  ConfigProvider,
  Pagination,
  Button,
  Input,
  Anchor,
  Collapse,
  Cascader,
  Checkbox,
  Row,
  Col,
  Modal,
  Spin,
} from "ant-design-vue";

Vue.component(ConfigProvider.name, ConfigProvider);
Vue.component(Pagination.name, Pagination);
Vue.component(Button.name, Button);
Vue.component(Input.name, Input);
Vue.component(Input.TextArea.name, Input.TextArea);
Vue.component(Collapse.name, Collapse);
Vue.component(Collapse.Panel.name, Collapse.Panel);
Vue.component(Anchor.name, Anchor);
Vue.component(Anchor.Link.name, Anchor.Link);
Vue.component(Cascader.name, Cascader);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Checkbox.Group.name, Checkbox.Group);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Spin.name, Spin);
Vue.use(Modal);
